import { useState, useMemo } from "react"
import "./8ball.css"
import adviceList from "./8ball.json"

const EightBall = () => {
    const jobs = Object.keys(adviceList);
    const [ job, setJob ] = useState(jobs[0]);
    const jobList = useMemo(() => adviceList[job], [job]);
    const choices = useMemo(() => jobList.length - 1, [jobList]);
    const [ choice, setChoice ] = useState(0);
    const [ shaken, setShaken ] = useState(false);


    return <div className="eightBallMain">
        <div className="eightBall">
            <div className="eightBallWindow">                
                {shaken && <div className="downTriangle"></div>}
                <p className="recommendation">{shaken ? <small>{adviceList[job][choice]}</small> : ""}</p>
            </div>
        </div>
        <div>
            {jobs.map((role) => <button key={role} className={ job === role ? "selectedMusicalJob" : "unselectedMusicalJob"} onClick={() => 
                {
                    setJob(role);
                    setShaken(false);
                }
            }>{role}</button>)}
        </div>
        <button className="shakerButton" onClick={() => {
            setChoice( Math.floor(Math.random() * (choices + 1)) );
            setShaken(true);
        }
        }>Shake the 8-ball</button>
    </div>
}

export default EightBall